import { AccessLevel } from '#pplx/frontend/components/types/types.js';
import { r2Asset } from '#pplx/frontend/r2-assets/r2Asset.js';
// framer should automatically detect language and localize, but in the meantime,
// we're manually setting urls.
export const LocalizedLegalLinks = {
    default: {
        termsOfService: 'https://www.perplexity.ai/hub/legal/terms-of-service',
        enterpriseTermsOfService: 'https://www.perplexity.ai/hub/legal/enterprise-terms-of-service',
        privacyPolicy: 'https://www.perplexity.ai/hub/legal/privacy-policy',
    },
    'ja-JP': {
        termsOfService: 'https://www.perplexity.ai/ja/hub/legal/terms-of-service',
        privacyPolicy: 'https://www.perplexity.ai/ja/hub/legal/privacy-policy',
    },
};
// Keep in sync with the backend: /pplx/backend/web/server/constants.py
export const MAX_CHARACTERS_ALLOWED_TO_SUBMIT = 40000;
export const MAX_PROMPT_INPUT_LENGTH = 2000;
export const MAX_COLLECTION_INSTRUCTIONS_LENGTH = 8000;
export const MAX_PROJECT_STATUS_SUMMARY_INSTRUCTION_LENGTH = 2000;
export const MAX_COLLECTION_TITLE_LENGTH = 50;
export const MAX_COLLECTION_DESCRIPTION_LENGTH = 1000;
export const MAX_PERSONALIZATION_LENGTH = 1500;
export const MAX_OCCUPATION_LENGTH = 200;
export const MAX_ORG_DESCRIPTION_LENGTH = 500;
export const MAX_ORG_ADMIN_MESSAGE_LENGTH = 350;
/**
 * Temporarily using the max-file-upload eppo flag instead in ask frontend for internal testing purposes.
 */
export const MAX_FILE_UPLOAD = 10;
// Keep in sync with MAX_FOCUSED_WEB_LINKS in pplx/common/core/collection/model.py
export const MAX_FOCUSED_WEB_LINKS = 100;
export const ERROR_MESSAGE_TIMEOUT = 5000;
// in case the backend doesn't return a max attachment file size, use this fallback
export const FALLBACK_MAX_FILE_UPLOAD_SIZE_MB = 50;
export const MIN_FILE_UPLOAD_SIZE = 10; // 10 bytes
export const BYTES_PER_MB = 1024 * 1024;
// Fallback daily upload limits used by FE if server settings are not loaded
export const FALLBACK_UPLOAD_DAILY_LIMIT_FREE = 3;
export const FALLBACK_UPLOAD_DAILY_LIMIT_SUBSCRIBED = 500;
export const PERPLEXITY_DEFAULT_SHARE_LOGO_URL = 'https://ppl-ai-public.s3.amazonaws.com/static/img/pplx-default-preview.png';
export const PERPLEXITY_PRO_SUMMARY_SHARE_URL = 'https://r2cdn.perplexity.com/perplexity-pro-og.png';
// Keep up to date with pplx/backend/core/version_utils.py
export const WEB_VERSION = '2.18';
export const WEB_SOURCE = 'default';
export const WINDOWS_APP_SOURCE = 'windowsapp';
export const IOS_SOURCE = 'ios';
export const ANDROID_SOURCE = 'android';
export const DEFAULT_RESPONSE_LANGUAGE = 'autodetect';
export const BLOCKED_UPLOAD_MIME_TYPES = [
    'audio/midi',
    'audio/x-midi',
    'application/zip',
    'application/x-tar',
    'application/x-bzip',
    'application/vnd.rar',
];
// Make sure to keep this in sync with pplx/backend/core/file_utils.py
export const ACCEPTED_FILE_TYPES = [
    '.bash',
    '.bat',
    '.c',
    '.coffee',
    '.conf',
    '.config',
    '.cpp',
    '.cs',
    '.css',
    '.csv',
    '.cxx',
    '.dart',
    '.diff',
    '.doc',
    '.docx',
    '.fish',
    '.go',
    '.h',
    '.hpp',
    '.htm',
    '.html',
    '.in',
    '.ini',
    '.ipynb',
    '.java',
    '.js',
    '.json',
    '.jsx',
    '.ksh',
    '.kt',
    '.kts',
    '.latex',
    '.less',
    '.log',
    '.lua',
    '.m',
    '.markdown',
    '.md',
    '.pdf',
    '.php',
    '.pl',
    '.pm',
    '.pptx',
    '.py',
    '.r',
    '.R',
    '.rb',
    '.rmd',
    '.rs',
    '.scala',
    '.sh',
    '.sql',
    '.swift',
    '.t',
    '.tex',
    '.text',
    '.toml',
    '.ts',
    '.tsx',
    '.txt',
    '.xlsx',
    '.xml',
    '.yaml',
    '.yml',
    '.zsh',
];
export const ACCEPTED_FILE_TYPES_IMAGES_ONLY = [
    '.jpeg',
    '.jpg',
    '.jpe',
    '.jp2',
    '.png',
    '.gif',
    '.bmp',
    '.tiff',
    '.tif',
    '.svg',
    '.webp',
    '.ico',
    '.avif',
    '.heic',
    '.heif',
];
export const ACCEPTED_FILE_TYPES_AUDIO_VIDEO_ONLY = [
    '.mp3',
    '.wav',
    '.aiff',
    '.ogg',
    '.flac',
    '.mp4',
    '.mpeg',
    '.mov',
    '.avi',
    '.flv',
    '.mpg',
    '.webm',
    '.wmv',
    '.3gp',
];
export const ACCEPTED_FILE_TYPES_IMAGES = [
    ...ACCEPTED_FILE_TYPES,
    ...ACCEPTED_FILE_TYPES_IMAGES_ONLY,
];
export const ACCEPTED_FILE_TYPES_ALL = [
    ...ACCEPTED_FILE_TYPES_IMAGES,
    ...ACCEPTED_FILE_TYPES_AUDIO_VIDEO_ONLY,
];
export const ACCEPTED_FILE_TYPES_STRING_ALL = ACCEPTED_FILE_TYPES_ALL.join(',');
export const DEFAULT_EMOJI = '';
export const FOLDER_EMOJI = '1f4c1';
export const DEFAULT_THREAD_ACCESS_LEVEL = AccessLevel.PRIVATE_READ;
export const DEFAULT_SPACE_ACCESS_LEVEL = AccessLevel.PRIVATE_READ;
export const DEFAULT_SEARCH_EXTENSION = 'https://chrome.google.com/webstore/detail/perplexity-ai-search/bnaffjbjpgiagpondjlnneblepbdchol';
export const MAC_DOWNLOAD_URL = 'https://pplx.ai/mac';
export const IOS_APP_STORE_WEB_URL = 'https://apps.apple.com/us/app/perplexity-ask-anything/id1668000334';
export const ANDROID_PLAY_STORE_WEB_URL = 'https://play.google.com/store/apps/details?id=ai.perplexity.app.android';
export const COMET_BROWSER_URL = 'https://www.perplexity.ai/comet';
export const UNINSTALL_EXTENSION_PARAM = 'uninstall_default_search_extension';
export const UTM_SOURCE_PARAM = 'utm_source';
export const LOGIN_SOURCE_PARAM = 'login-source';
export const LOGIN_NEW_PARAM = 'login-new';
export const PARTNER_CODE_PARAM = 'partner-code';
export const MAX_PAYWALL_PARAM = 'max';
export const Q_PARAM = 'q';
export const QFILL_PARAM = 'qfill';
export const QSKILLS_PARAM = 'qskills';
export const QSOURCES_PARAM = 'qsources';
/** External qfill compatibility flag for resolving `qsources` past the cache. */
export const QSOURCES_REFRESH_PARAM = 'qsources_refresh';
export const QSOURCE_SUGGESTIONS_PARAM = 'qsource_suggestions';
export const QMODE_PARAM = 'qmode';
export const QMODEL_PARAM = 'qmodel';
export const QMODEL_ID_PARAM = 'model_id';
export const QATTACH_PARAM = 'qattach';
export const QATTACH_NAME_PARAM = 'qattach_name';
export const QREMIX_PARAM = 'qremix';
export const QRELATED_QUERY_UUID_PARAM = 'qrquuid';
export const FROM_COMPUTER_UPSELL_PARAM = 'fromComputerUpsell';
export const TRACKED_SINGULAR_USER_SUBSCRIBED_PAYING_KEY = 'pplx.tracked_singular_user_subscribed_paying';
export const COMET_PARTNER_REDEMPTION_ID_URL_PARAM = 'comet_redemption_id';
export const COMET_PARTNER_REDEMPTION_ID_COOKIE_KEY = 'pplx.comet-partner-redemption-id';
export const COMET_PARTNER_CODE_COOKIE_KEY = 'pplx.comet-partner-code';
export const COMET_PARTNER_COOKIE_EXPIRATION_DAYS = 1;
export const RECURRING_GATE_IMPRESSIONS_LIMIT = 5;
export const FACTSET_AVATAR = '/static/images/data-connectors/factset/factset-avatar.svg';
export const FACTSET_FORMATTED_NAME = 'FactSet';
export const CRUNCHBASE_AVATAR = '/static/images/data-connectors/crunchbase/crunchbase-avatar.svg';
export const CRUNCHBASE_FORMATTED_NAME = 'Crunchbase';
// Premium branded source constants moved to pplx/frontend/branded-sources/consts.ts
// Import from there: WILEY_*, CBINSIGHTS_*, PITCHBOOK_*, STATISTA_*
export const FINANCE_AVATAR = '/static/images/data-connectors/finance-portfolio/finance-portfolio-avatar.svg';
export const PLAID_FORMATTED_NAME = 'Plaid';
export const GOOGLE_DRIVE_AVATAR = '/static/images/data-connectors/google/google-drive-avatar.svg';
export const GMAIL_AVATAR = '/static/images/data-connectors/google/gmail-avatar.svg';
export const GMAIL_FORMATTED_NAME = 'Gmail';
export const GOOGLE_DRIVE_FORMATTED_NAME = 'Google Drive';
export const GOOGLE_CALENDAR_AVATAR = '/static/images/data-connectors/google/gcal-gmail-avatar.svg';
export const GOOGLE_CALENDAR_FORMATTED_NAME = 'Gmail with Calendar';
export const MICROSOFT_FORMATTED_NAME = 'Microsoft';
export const ONEDRIVE_AVATAR = '/static/images/data-connectors/microsoft/onedrive-avatar.svg';
export const ONEDRIVE_FORMATTED_NAME = 'OneDrive';
export const SHAREPOINT_AVATAR = '/static/images/data-connectors/microsoft/sharepoint-avatar.svg';
export const SHAREPOINT_FORMATTED_NAME = 'SharePoint';
export const WORD_AVATAR = '/static/images/data-connectors/microsoft/word-avatar.svg';
export const POWERPOINT_AVATAR = '/static/images/data-connectors/microsoft/powerpoint-avatar.svg';
export const DROPBOX_AVATAR = '/static/images/data-connectors/dropbox/dropbox-avatar.svg';
export const DROPBOX_FORMATTED_NAME = 'Dropbox';
export const BOX_AVATAR = '/static/images/data-connectors/box/box-avatar.svg';
export const BOX_FORMATTED_NAME = 'Box';
export const NOTION_AVATAR = '/static/images/data-connectors/notion/notion-avatar.svg';
export const NOTION_FORMATTED_NAME = 'Notion';
export const LINEAR_AVATAR = '/static/images/data-connectors/linear/linear-avatar.svg';
export const LINEAR_FORMATTED_NAME = 'Linear';
export const SLACK_AVATAR = '/static/images/data-connectors/slack/slack-avatar.svg';
export const SLACK_FORMATTED_NAME = 'Slack (deprecated)';
export const SLACK_DIRECT_FORMATTED_NAME = 'Slack';
export const GITHUB_AVATAR = '/static/images/data-connectors/github/github-avatar.svg';
export const GITHUB_FORMATTED_NAME = 'GitHub';
export const ASANA_AVATAR = '/static/images/data-connectors/asana/asana-avatar.svg';
export const ASANA_FORMATTED_NAME = 'Asana';
export const ATLASSIAN_AVATAR = '/static/images/data-connectors/atlassian/atlassian-avatar.svg';
export const ATLASSIAN_FORMATTED_NAME = 'Atlassian';
export const JIRA_AVATAR = '/static/images/data-connectors/jira/jira-avatar.svg';
export const JIRA_FORMATTED_NAME = 'Jira';
export const CONFLUENCE_AVATAR = '/static/images/data-connectors/confluence/confluence-avatar.svg';
export const CONFLUENCE_FORMATTED_NAME = 'Confluence';
export const MICROSOFT_TEAMS_AVATAR = '/static/images/data-connectors/microsoft/teams-avatar.svg';
export const MICROSOFT_TEAMS_FORMATTED_NAME = 'Microsoft Teams';
// OAuth
export const PPLX_OAUTH_CALLBACK_PREFIX = 'pplx-oauth:///callback';
// Voice
/**
 * Used for the Windows desktop app
 */
// Broadcast channel names
export const SUBMIT_QUERY_CHANNEL = 'submit-query';
export const SEARCH_MODEL_CHANGE_CHANNEL = 'search-model-change';
export const SOURCE_SELECTION_CHANGE_CHANNEL = 'source-selection-change';
export const WINDOWS_APP_PREFIX = 'windows-app';
export const WINDOWS_APP_CLIENT_ID = WINDOWS_APP_PREFIX;
export const WINDOWS_APP_REDIRECT_TOKEN = 'If4YwAeizGHdB3eOhX2JxYcjeCgy0N9c';
/**
 * Used for the macOS desktop app
 */
export const MACOS_APP_PREFIX = 'macos-app';
export const MACOS_APP_CLIENT_ID = MACOS_APP_PREFIX;
export const MACOS_DEEPLINK_CALLBACK_PATH = 'login/apple-callback';
export const VALID_MACOS_SCHEMES = new Set([
    'perplexity-desktop',
    'perplexity-desktop-beta',
    'perplexity-computer',
]);
const RELATIVE_WINDOWS_ASK_INPUT_PATH = `/ask/input`;
export const ABSOLUTE_WINDOWS_ASK_INPUT_PATH = `/${WINDOWS_APP_PREFIX}${RELATIVE_WINDOWS_ASK_INPUT_PATH}`;
// Direct installer download for the NEW native Windows app — the browser-safe
// counterpart to the ms-windows-store: deep link below.
export const WINDOWS_APP_INSTALLER_URL = 'https://get.microsoft.com/installer/download/9P9XG917PWCJ';
export const WINDOWS_DOWNLOAD_URL = WINDOWS_APP_INSTALLER_URL;
// ms-windows-store: deep link to the NEW Windows app. Opens the Store app
// directly, but only resolves when opened on Windows / from inside a Windows app
// — not from a cross-platform web CTA (that needs the installer URL above).
export const MICROSOFT_STORE_DEEPLINK_URL = 'ms-windows-store://pdp/?productid=9P9XG917PWCJ';
export const WINDOWS_APP_DICTATION_CONFIG = {
    silenceThreshold: 30,
    silenceDuration: 5000,
};
export const BASE_SUPPORTED_BLOCK_USE_CASES = [
    'answer_modes',
    'media_items',
    'inline_entity_cards',
    'place_widgets',
    'finance_widgets',
    'news_widgets',
    'shopping_widgets',
    'search_result_widgets',
    'inline_images',
    'inline_assets',
    'placeholder_cards',
    'diff_blocks',
    'entity_group_v2',
    'refinement_filters',
    'canvas_mode',
    'maps_preview',
    'answer_tabs',
    'preserve_latex',
    'in_context_suggestions',
    'pending_followups',
    'inline_claims',
    'unified_assets',
    'workflow_steps',
    'workflow_widgets',
    'navigation_results',
    'background_agents',
];
export const ASSET_DIFF_ASSETS_BLOCK_USE_CASE = 'asset_diff_assets';
export const ASK_USER_QUESTION_EMPTY_OPTIONS_BLOCK_USE_CASE = 'ask_user_question_empty_options';
export const ASK_USER_QUESTION_DELTA_BLOCK_USE_CASE = 'ask_user_question_delta';
export const WRITE_DELTA_BLOCK_USE_CASE = 'write_delta';
export const BASH_DELTA_BLOCK_USE_CASE = 'bash_delta';
export const RUN_SUBAGENT_DELTA_BLOCK_USE_CASE = 'run_subagent_delta';
export const CONFIRM_ACTION_DELTA_BLOCK_USE_CASE = 'confirm_action_delta';
export const ACCESSORY_BLOCKS_BLOCK_USE_CASE = 'accessory_blocks';
export const ASI_SUPPORTED_BLOCK_USE_CASES = [
    ...BASE_SUPPORTED_BLOCK_USE_CASES,
    ASSET_DIFF_ASSETS_BLOCK_USE_CASE,
    ASK_USER_QUESTION_EMPTY_OPTIONS_BLOCK_USE_CASE,
    ASK_USER_QUESTION_DELTA_BLOCK_USE_CASE,
    WRITE_DELTA_BLOCK_USE_CASE,
    BASH_DELTA_BLOCK_USE_CASE,
    RUN_SUBAGENT_DELTA_BLOCK_USE_CASE,
    CONFIRM_ACTION_DELTA_BLOCK_USE_CASE,
    ACCESSORY_BLOCKS_BLOCK_USE_CASE,
];
export const FILE_BASED_CONNECTORS = [
    'google_drive',
    'onedrive',
    'sharepoint',
    'dropbox',
    'box',
];
// These are the file based connectors that attachments can be uploaded from.
export const ATTACHMENT_FILE_BASED_CONNECTORS = [
    'google_drive',
    'onedrive',
    'sharepoint',
    'dropbox',
    'box',
];
export const OUTLOOK_FORMATTED_NAME = 'Outlook';
export const OUTLOOK_AVATAR = '/static/images/data-connectors/microsoft/outlook-avatar.svg';
export const ZOOM_FORMATTED_NAME = 'Zoom';
export const ZOOM_AVATAR = '/static/images/data-connectors/zoom/zoom-avatar.svg';
export const MEDICAL_RECORDS_FORMATTED_NAME = 'Medical Records';
export const MEDICAL_RECORDS_AVATAR = r2Asset('source-icons/medical-records.webp');
export const FUNCTION_HEALTH_FORMATTED_NAME = 'Function Health';
export const FUNCTION_HEALTH_AVATAR = r2Asset('source-icons/function_health.webp');
export const ORG_UPGRADE_IN_PROGRESS_SESSION_STORAGE_KEY = 'org-upgrade-in-progress';
export const ORG_ONBOARDING_SUCCESS_REDIRECT_KEY = 'org-onboarding-success-redirect';
export const ENTERPRISE_ONBOARDING_PENDING_KEY = 'enterprise-onboarding-pending';
//# sourceMappingURL=consts.js.map